// extracted by mini-css-extract-plugin
export default {"footerContent":"SignedCommitFooter-module__footerContent__KgGfNwN","Link":"SignedCommitFooter-module__Link__PoyYTBV","Link_1":"SignedCommitFooter-module__Link_1__MCOWjO8"};